import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Sectors',
    href: '/sectors'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-sm py-4 border-b border-navy-border shadow-lg' : 'bg-transparent py-6'}`} data-id="element-103">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-104">
        <Link to="/" className="hover:opacity-90 transition-opacity" data-id="element-105">
          <Logo data-id="element-106" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-107">
          {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors ${location.pathname === link.href ? 'text-gold' : 'text-slate-300 hover:text-gold'}`} data-id="element-108">
              {link.name}
            </Link>)}
        </nav>

        <div className="hidden md:block" data-id="element-109">
          <Link to="/pre-qualification" className="bg-gold hover:bg-gold-light text-navy font-semibold text-sm px-6 py-2.5 rounded transition-colors" data-id="element-110">
            Pre-Qualification Form
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-111">
          {mobileMenuOpen ? <X size={24} data-id="element-112" /> : <Menu size={24} data-id="element-113" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-navy-card border-b border-navy-border shadow-xl py-4 px-6 flex flex-col gap-4" data-id="element-114">
          {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-base font-medium py-2 border-b border-navy-border/50 ${location.pathname === link.href ? 'text-gold' : 'text-slate-300 hover:text-gold'}`} onClick={() => setMobileMenuOpen(false)} data-id="element-115">
              {link.name}
            </Link>)}
          <Link to="/pre-qualification" className="bg-gold text-navy font-semibold text-center text-sm px-6 py-3 mt-2 rounded" onClick={() => setMobileMenuOpen(false)} data-id="element-116">
            Pre-Qualification Form
          </Link>
        </div>}
    </header>;
}